import { useMutation, useQueryClient } from 'react-query'

import StepService from 'src/services/steps.service'

import { QUERY_KEYS } from 'src/constants'
import { IAccountByIdRespDto, IStepsRespDto } from 'src/types'
import { DEFAULT_LANGUAGE_CODE } from 'src/components/languages/langauges-list/constants'
import { useParams } from 'react-router-dom'

const useRemoveSteps = (locale?: string) => {
  const { accountId } = useParams()
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => StepService.removeSteps(ids), {
    onSuccess: (_, ids) => {
      queryClient.setQueriesData(QUERY_KEYS.STEPS, (prev?: IStepsRespDto) => {
        return prev
          ? {
              ...prev,
              data: prev.data.filter((item) => !ids.includes(item.id)),
              count: prev.count - ids.length,
            }
          : { count: 0, data: [] }
      })

      queryClient.setQueryData(
        [QUERY_KEYS.ACCOUNT, accountId, locale ?? DEFAULT_LANGUAGE_CODE],
        (prev?: IAccountByIdRespDto) => {
          return prev
            ? { ...prev, stepsCount: prev.stepsCount - ids.length }
            : ({} as IAccountByIdRespDto)
        },
      )
    },
  })
}

export { useRemoveSteps }
